export function isSuperUser() {
  const fromLocalStorage = localStorage.getItem("auth_superuser") || false;

  if (typeof fromLocalStorage === "boolean") {
    return fromLocalStorage;
  }

  return fromLocalStorage !== "false";
}



// WEBPACK FOOTER //
// ./src/utils/is-superuser.js